import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class GuestWelcomeGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    // Verifica se o usuário veio de /guest/register
    const navigation = this.router.getCurrentNavigation();
    const fromRegister = navigation?.previousNavigation?.finalUrl?.toString().startsWith('/guest/register') ||
      navigation?.previousNavigation?.extractedUrl?.toString().startsWith('/guest/register');

    if (fromRegister) {
      return true;
    }
    // Redireciona para /guest/register se não veio de lá
    return this.router.parseUrl('/guest/register');
  }
} 